import { ArrowBack } from "@mui/icons-material";
import {
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import React, { useState } from "react";
import { Container } from "reactstrap";
import MuiButton from "../../components/muibutton";
import { useNavigate, useParams } from "react-router-dom";
import "../../custom.css";
import MuiChip from "../../components/muichip";
import { getAPIwithParams, patchAPI } from "../../services/basehttpAPI";
import { useEffect } from "react";
import { formatDate } from "../../utils/utils";
import * as BusinessConst from "../../utils/businessconstants";
import SnackbarComponent from "../../components/snackbar";


const ViewUser = () => {
  const [userData = [], setUserData] = useState();
  const [customerProfileList = [], setCustomerProfileList] = useState();
  const [shipToPartyList = [], setShipToPartyList] = useState();
  const [open, setOpen] = useState(false);

  const [opensnackbar, setopensnackbar] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);

  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));

  const navigate = useNavigate([]);
  const params = useParams();
  const userid = params.userid;
  const editurl = `/layout/edituser/${userid}`;
  const userlisturl = `/layout/users`;


  const getApplicationUserbyId = async () => {
    let url = "ApplicationUser/GetApplicationUserById";
    const userModel = {
      id: userid,
    };
    const response = await getAPIwithParams(url, userModel);
    const data = response.responseData;
    setUserData(data);
  };

  useEffect(() => {
    getApplicationUserbyId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
      setCustomerProfileList(userData.userCustomerProfile);
      setShipToPartyList(userData.userShipToParty);
  }, [userData]);

  const handleNavigation = () => {
    navigate(editurl);
    }

  const DeleteUser = async () => {
    let DeleteURL = "ApplicationUser/DeleteApplicationUserById?endUserId=" + userid;
    const response = await patchAPI(DeleteURL);
    if (response.isSuccess == true) {
      navigate(userlisturl, {
        state: {
          Snackbaropen: true,
        },
      });
    }
    else {
      setseverity("error");
      setmessage("Unable to delete the user!");
      setopensnackbar(true);
      setOpen(false);
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackBarClose = () => {
    setopensnackbar(false);
  };

  return (
    <Container sx={{ ml: "10px" }}>
          <Typography variant="h5" flexGrow={1} sx={{ pl: "24px" }}>
              {translatedText?.user}
      </Typography>
      <Box>
        <Paper sx={{ width: "80%", mt: "20px", ml: "20px" }}>
          <Box sx={{ height: "60px", backgroundColor: "#F4F7FC" }}>
            <Stack
              useFlexGap
              flexWrap="wrap"
              direction="row"
              spacing={{ xs: 0.5, sm: 2, md: 4 }}
              sx={{ paddingTop: "10px", mr: "10px" }}>
              <IconButton onClick={() => navigate("/layout/users")}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h6" flexGrow={1} sx={{ pt: "5px" }}>
                {userData.firstName},{userData.lastName}
              </Typography>
              {userData.userRoleKey === BusinessConst.endUser_TranslationLabel && (
                <Button variant="contained" color="error" onClick={handleClickOpen}>
                  Delete
                </Button>
              )}
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to delete this item? This action cannot be undone.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} color="primary">
                    Cancel
                  </Button>
                  <Button onClick={DeleteUser} color="error">
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              <SnackbarComponent
                open={opensnackbar}
                handleClose={handleSnackBarClose}
                message={message}
                severity={severity}
              />
              <MuiButton
                type="button"
                              text={translatedText?.edit}//"Edit"
                color="warning"                
                onClick={handleNavigation}
                show = {true}
              />
            </Stack>
          </Box>
          <Grid container spacing={2} sx={{ m: "20px", mb: "30px" }}>
            <Grid item xs={12} sm={12} md={2}>
              <span className="fontcolor label-txt">{userData.firstName}</span>
                          <div className="fontheadercolor label-txt"> {translatedText?.first_name}</div>
            </Grid>
            <Grid item xs={12} sm={12} md={2}>
              <span className="fontcolor label-txt">{userData.lastName}</span>
                          <div className="fontheadercolor label-txt">{translatedText?.last_name}</div>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <div>
                <span className="fontcolor label-txt">{userData.email}</span>
                              <div className="fontheadercolor label-txt">{translatedText?.email_id}</div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <div>
                <span className="fontcolor label-txt">
                  {userData.lastLogin ? formatDate(userData.lastLogin) : " - "}
                </span>
                              <div className="fontheadercolor label-txt">{translatedText?.last_login}</div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={2}>
                          <MuiChip row={userData} statusKey={"isActive"} ></MuiChip>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ m: "20px", mb: "50px" }}>
            <Grid item xs={12} sm={12} md={3}>
              <div>
                <span className="fontcolor label-txt">
                  {userData.userRole ? userData.userRole : " - "}
                </span>
                              <div className="fontheadercolor label-txt">{translatedText?.user_role}</div>
              </div>
            </Grid>
          </Grid>
          <Divider />
          {userData.userRoleKey === BusinessConst.endUser_TranslationLabel && (
            <>              
              <Grid container spacing={2} sx={{ m: "20px", mb: "50px" }}>
                <Grid item xs={4}>
                  <Typography sx={{ mb: "10px", fontWeight: "600" }}>
                                      {translatedText?.customer_access}
                  </Typography>
                  <List>
                    {customerProfileList.length > 0 ? (
                      customerProfileList.map((cust) => {
                        return (
                          <ListItem key={cust.id}>
                            <ListItemText>
                              <span className="fontcolor label-txt">
                                {" "}
                                {cust.customerName}{" "}
                              </span>
                              <span className="fontheadercolor label-txt">
                                {" "}
                                /{cust.indasId}
                              </span>
                            </ListItemText>
                          </ListItem>
                        );
                      })
                    ) : (
                      <ListItem>
                                                  <ListItemText>{translatedText?.no_records_found}</ListItemText>
                      </ListItem>
                    )}
                  </List>
                              </Grid>

                              <Grid item xs={4}>
                                  <Typography sx={{ mb: "10px", fontWeight: "600" }}>
                                      {"Ship To Party Details"}
                                  </Typography>
                                  <List>
                                      {shipToPartyList.length > 0 ? (
                                          shipToPartyList.map((ship) => {
                                              return (
                                                  <ListItem key={ship.id}>
                                                      <ListItemText>
                                                          <span className="fontcolor label-txt">
                                                              {" "}
                                                              {(ship.customShipToPartyName || ship.shipToPartyName)}{" "}
                                                          </span>
                                                      </ListItemText>
                                                  </ListItem>
                                              );
                                          })
                                      ) : (
                                          <ListItem>
                                              <ListItemText>{"No records found"}</ListItemText>
                                          </ListItem>
                                      )}
                                  </List>
                              </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default ViewUser;
